import React from 'react';
import { FileText, Image, BookOpen } from 'lucide-react';

/**
 * Componente de menu para inserir novos itens (texto, imagem ou tema)
 */
const InsertMenu = ({ onInsertText, onInsertImage, onInsertTema, onCancel }) => {
  return (
    <div className="insert-menu">
      <p className="insert-menu-title">
        Escolha o tipo de conteúdo:
      </p>
      <div className="flex-row flex-wrap gap-8">
        <button
          onClick={onInsertText}
          className="ikaro-btn ikaro-btn-sm ikaro-btn-primary"
        >
          <FileText size={16} />
          Texto
        </button>
        <button
          onClick={onInsertImage}
          className="ikaro-btn ikaro-btn-sm ikaro-btn-purple"
        >
          <Image size={16} />
          Imagem
        </button>
        {onInsertTema && (
          <button
            onClick={onInsertTema}
            className="ikaro-btn ikaro-btn-sm ikaro-btn-success"
          >
            <BookOpen size={16} />
            Tema
          </button>
        )}
        <button
          onClick={onCancel}
          className="ikaro-btn ikaro-btn-sm ikaro-btn-secondary"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default InsertMenu;
